import { Components, Theme } from '@mui/material/styles'

/**
 * ## `text.primary`, not `primary.contrastText` — and this one is LATENT, not a live defect
 *
 * Same bug shape as `MuiCheckbox.ts` (see its docstring for the full argument):
 * `contrastText` is the colour legible ON the primary colour, i.e. on a
 * primary-FILLED surface. A radio is not on one — it sits on the ordinary white
 * cards, drawers and sheets this app is made of. `primary.main` defaults to BLACK
 * (`./palette.ts`), so MUI computes `contrastText` as `#fff` and an unstyled radio
 * would paint white on white. Verified in the browser: every emitted rule derived
 * from `primary.contrastText` carries the literal `color:#fff`.
 *
 * ## No screen is broken by this today — say so honestly
 *
 * `<Radio` appears at exactly ONE place in `apps/app/src`, and that file is DEAD:
 * `components/pages/certificates/CertificatesSort.tsx` was imported from nowhere
 * (deleted alongside this change). The live Sort sheet is
 * `components/UI/SortDrawer.tsx` / `SortField.tsx`, which renders plain text rows
 * and no radios at all. Confirmed in a running browser: `.MuiRadio-root` matches 0
 * elements on the certificates list (including its keep-mounted drawers), the
 * public certificate page and the access gate.
 *
 * So this is fixed as a trap for whoever writes the app's first real radio, NOT
 * because a user is looking at an invisible control. A theme default being wrong
 * does not prove a screen is broken, and the two claims should not be blurred.
 */
export const MuiRadio: Components<Theme>['MuiRadio'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.text.primary,
      '&.Mui-checked': {
        color: theme.palette.text.primary,
      },
    }),
  },
}
